export default ".mat-form-field-infix {\n  width: 185px !important;\n}"